import { Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  position: string;
  onClose: () => void;
  onApply: () => void;
  onClear: () => void;
};

export default function CustomToolbar({ onClose, onApply, onClear }: Props) {
  const { t } = useTranslation('common');

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        gap: 1,
        py: 1,
        pr: 1,
      }}>
      <Button
        variant="text"
        sx={{
          color: 'text.primary',
        }}
        onClick={() => {
          onClear();
          onClose();
        }}>
        {t('calendar.cancel')}
      </Button>
      <Button
        variant="text"
        sx={{
          color: 'text.primary',
        }}
        onClick={() => {
          onApply();
          onClose();
        }}>
        {t('calendar.ok')}
      </Button>
    </Box>
  );
}
